exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js!./assets/css/custom.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */ ", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/styles.css
// module id = 385
// module chunks = 5